export default "__VITE_ASSET__CpdnocGr__"